import React, { useEffect, useState } from 'react';
import StatisticsCard from '../statistics-card/StatisticsCard';
import CustomDualAxesChart from '../../../shared/charts/custom-dual-axes-chart/CustomDualAxesChart';
import CustomLineChart from '../../../shared/charts/custom-line-chart/CustomLineChart';
import StatisticsItemList from '../statistics-item-list/StatisticsItemList';
import CustomColumnChart from '../../../shared/charts/custom-column-chart/CustomColumnChart';
import moment from 'moment/moment';
import { statisticsDataKeys } from '../../analytics/Analytics';
import WidgetWrapper from '../../analytics/WidgetWrapper';

function Ird(props) {
  const { allStatisticsData, showAllForReport = false, currency } = props;
  const [busiestDayOfWeek, setBusiestDayOfWeek] = useState([]);
  const [busiestTimeOfDay, setBusiestTimeOfDay] = useState([]);
  const [mostOrderedItems, setMostOrderedItems] = useState([]);
  const [orderTrend, setOrderTrend] = useState([]);
  const [unpopularItems, setUnpopularItems] = useState([]);
  const [avgItemsOnOrder, setAvgItemsOnOrder] = useState([]);
  const [popularItems, setPopularItems] = useState([]);

  useEffect(() => {
    const statisticValues = {
      busiestDayOfWeek: setBusiestDayOfWeek,
      busiestTimeOfDay: setBusiestTimeOfDay,
      mostOrderedItems: setMostOrderedItems,
      orderTrend: setOrderTrend,
      unpopularItems: setUnpopularItems,
      avgItemsOnOrder: setAvgItemsOnOrder,
      popularItems: setPopularItems,
    };

    for (const key of Object.keys(statisticValues)) {
      if (allStatisticsData && allStatisticsData[key]) {
        statisticValues[key](allStatisticsData[key]);
      }
    }
  }, [allStatisticsData]);

  return (
    <div className='col-12 d-flex flex-wrap gap-2 arrival-container'>
      {/* Temporarily disable */}
      {/* <div className="col-auto col-sm-12 col-md-auto col-lg-auto">
        <StatisticsCard
          key={1}
          currencyCode={allStatisticsData?.currencyCode}
          data={[
            { name: "Orders", value: allStatisticsData?.totalOrderCount },
            {
              name: "Transaction",
              value: allStatisticsData?.totalAmount,
            },
            {
              name: "Revenue",
              value: allStatisticsData?.totalUpsellAmount,
            },
          ]}
        />
      </div> */}
      {orderTrend?.length > 0 && (
        <div className='col-auto col-sm-12 col-md col-lg box-shadow custom-card mw-100'>
          <div className='h-100 w-100 mw-100 mh-100'>
            <CustomDualAxesChart
              title={'IRD Trend'}
              xAxis={statisticsDataKeys?.date}
              yAxis1={statisticsDataKeys?.orderAmount}
              yAxis2={statisticsDataKeys?.orderCount}
              currency={currency}
              data={orderTrend?.map((order, index) => {
                return {
                  Date: moment(new Date(order?.date)).format(statisticsDataKeys?.dateFormat),
                  [statisticsDataKeys?.orderAmount]: order?.orderAmount,
                  [statisticsDataKeys?.orderCount]: order?.orderCount,
                };
              })}
            />
          </div>
        </div>
      )}
      {avgItemsOnOrder?.length > 0 && (
        <div className='h-100 w-100 mw-100 mh-100'>
          <WidgetWrapper title={'Avg Items On Order'} width='95%' isCustom={true}>
            <CustomLineChart
              xAxis={statisticsDataKeys?.date}
              yAxis={statisticsDataKeys?.avgOrderItemsCount}
              data={avgItemsOnOrder?.map((order, index) => {
                return {
                  Date: moment(new Date(order?.date)).format(statisticsDataKeys?.dateFormat),
                  [statisticsDataKeys?.avgOrderItemsCount]: order?.avgOrderItemsCount,
                };
              })}
              includeCard={true}
              tooltipItems={[statisticsDataKeys?.avgOrderItemsCount]}
              additionalData={[
                {
                  name: statisticsDataKeys?.avgItemsPerOrder,
                  value: allStatisticsData?.avgItemsPerOrder?.toFixed(2),
                },
                {
                  name: statisticsDataKeys?.medianItemsPerOrder,
                  value: allStatisticsData?.medianItemsPerRequest || 0,
                },
              ]}
            />
          </WidgetWrapper>
        </div>
      )}
      <div className='col-12 box-shadow custom-card mw-100 mh-100 d-flex flex-wrap gap-2 p-2'>
        <div className='d-flex col-12 col-md-12 col-lg-12 flex-wrap px-2 mw-100'>
          {popularItems?.length > 0 && (
            <div className='col-12 col-md-6 col-lg-4'>
              <div className='px-2'>
                <StatisticsItemList
                  title='Most Ordered Items'
                  itemListHeight={true}
                  key={2}
                  numberField={statisticsDataKeys?.orderCount}
                  columnNames={[statisticsDataKeys?.name, statisticsDataKeys?.orderCount]}
                  items={popularItems?.map((items) => {
                    return {
                      [statisticsDataKeys?.name]: items?.itemName || '---',
                      [statisticsDataKeys?.orderCount]: items?.count,
                    };
                  })}
                  showAllForReport={showAllForReport}
                  showErrorsList={true}
                />
              </div>
            </div>
          )}
          {popularItems?.length > 0 && (
            <div className='col-12 col-md-6 col-lg-4'>
              <div className='px-2'>
                <StatisticsItemList
                  title='Unpopular Items'
                  key={3}
                  itemListHeight={true}
                  numberField={statisticsDataKeys?.daysSinceLastOrdered}
                  columnNames={[statisticsDataKeys?.name, statisticsDataKeys?.daysSinceLastOrdered]}
                  items={popularItems?.map((items) => {
                    return {
                      [statisticsDataKeys?.name]: items?.itemName || '---',
                      [statisticsDataKeys?.daysSinceLastOrdered]: items?.daysSinceLastOrdered,
                    };
                  })}
                  showAllForReport={showAllForReport}
                  showErrorsList={true}
                />
              </div>
            </div>
          )}
          <div className='col-12 col-md-12 col-lg-4 d-flex flex-column gap-2'>
            {busiestDayOfWeek?.length > 0 && (
              <div className='col-12 h-50'>
                <CustomColumnChart
                  title={statisticsDataKeys?.busiestDayOfTheWeek}
                  xAxis='Day'
                  yAxis={statisticsDataKeys?.orderCount}
                  data={busiestDayOfWeek?.map((dayData, index) => {
                    return {
                      Day: dayData?.day,
                      [statisticsDataKeys?.orderCount]: dayData?.orderCount,
                    };
                  })}
                />
              </div>
            )}
            {busiestTimeOfDay?.length > 0 && (
              <div className='col-12 h-50'>
                <CustomColumnChart
                  title={statisticsDataKeys?.busiestTimeOfTheDay}
                  xAxis='Time'
                  yAxis={statisticsDataKeys?.orderCount}
                  data={busiestTimeOfDay?.map((timeData, index) => {
                    return {
                      Time: timeData?.time,
                      [statisticsDataKeys?.orderCount]: timeData?.orderCount,
                    };
                  })}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ird;
